/*
 *
 * ElectronicPurse Actions
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 03-Nov-2022
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	DO_SET_ITEM_TO_SHOW_DETAIL: '@@ElectronicPurse/set_item_to_show_detail',
	DO_RESET_ERROR: '@@ElectronicPurse/reset_error',
	// @generator action:route:type
	...createRequestTypes('@@ElectronicPurse', 'FETCH_ELECTRONIC_PURSE_LIST'),
	...createRequestTypes('@@ElectronicPurse', 'CREATE_ELECTRONIC_PURSE'),
	...createRequestTypes('@@ElectronicPurse', 'DELETE_ELECTRONIC_PURSE'),
	...createRequestTypes('@@ElectronicPurse', 'UPDATE_ELECTRONIC_PURSE'),
	...createRequestTypes('@@ElectronicPurse', 'FIND_ELECTRONIC_PURSE'),
	...createRequestTypes('@@ElectronicPurse', 'DOWNLOAD_E_PURSE_REPORT'),
	...createRequestTypes('@@ElectronicPurse', 'GENERATE_E_PURSE_REPORT_STATUS'),
	...createRequestTypes('@@ElectronicPurse', 'REPORT_PROGRESS'),
	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Insert a description
 * @name generateEPurseReportStatus
 * @return {object} - The action object
 */
export const generateEPurseReportStatus = new MakeRequest('ElectronicPurse', 'generate_e_purse_report_status');
/** @action request
 * * Insert a description
 * @name downloadEPurseReport
 * @return {object} - The action object
 */
export const downloadEPurseReport = new MakeRequest('ElectronicPurse', 'download_e_purse_report');
/** @action request
 * * Insert a description
 * @name findElectronicPurse
 * @return {object} - The action object
 */
export const findElectronicPurse = new MakeRequest('ElectronicPurse', 'find_electronic_purse');
/** @action request
 * * Insert a description
 * @name updateElectronicPurse
 * @return {object} - The action object
 */
export const updateElectronicPurse = new MakeRequest('ElectronicPurse', 'update_electronic_purse');
/** @action request
 * * Insert a description
 * @name deleteElectronicPurse
 * @return {object} - The action object
 */
export const deleteElectronicPurse = new MakeRequest('ElectronicPurse', 'delete_electronic_purse');
/** @action request
 * * Insert a description
 * @name createElectronicPurse
 * @return {object} - The action object
 */
export const createElectronicPurse = new MakeRequest('ElectronicPurse', 'create_electronic_purse');
/** @action request
 * * Insert a description
 * @name fetchElectronicPurseList
 * @return {object} - The action object
 */
export const fetchElectronicPurseList = new MakeRequest('ElectronicPurse', 'fetch_electronic_purse_list');
/** @action
 * * Insert a description
 * @name ResetError
 * @return {object} - The payload object
 */
/** @action request
 * * Insert a description
 * @name reportProgress
 * @return {object} - The action object
 */
export const reportProgress = new MakeRequest('ElectronicPurse', 'report_progress');

// @generator action:route:request

export const doResetError = (payload) => createAction(actionTypes.DO_RESET_ERROR, { payload });
/** @action
 * * Insert a description
 * @name SetItemToShowDetail
 * @return {object} - The payload object
 */
export const doSetItemToShowDetail = (payload) => createAction(actionTypes.DO_SET_ITEM_TO_SHOW_DETAIL, { payload });

// @generator action:route
